import { useNodePath } from './useNodePath';

export const useBreadcrumb = (data, selectedSubcategory) => {
  const { fullPath } = useNodePath(data, selectedSubcategory);
  return fullPath;
};
